/**
 * @file index.tsx
 *
 * @fileoverview Renders matching jobs for published job detail pages.
 */

import JobRecommenderLayout from '~/jobiqo/components/JobRecommender/components/Layout';
import { useQuery } from '@apollo/client';
import getMatchingJobs from '~/jobiqo/components/JobRecommender/graphql/queries/getMatchingJobs';
import { FormattedMessage } from 'react-intl';

interface JobRecommenderJobs2JobProps {
  /**
   * The job id.
   */
  jobId: number;
}

export default function JobRecommenderJobs2Job({
  jobId,
}: JobRecommenderJobs2JobProps) {
  const { data, error, loading } = useQuery(getMatchingJobs(), {
    variables: {
      context: 'JOB_DETAIL_PUBLISHED',
      entityId: jobId,
    },
  });
  const matchingResult = data?.getMatchingJobs;

  return (
    <JobRecommenderLayout
      loading={loading}
      error={
        !!error || (matchingResult?.errors && matchingResult.errors.length > 0)
      }
      jobs={matchingResult?.items?.map((item: any) => item.job)}
      Description={
        <FormattedMessage
          id="job_recommender_jobs2job_description"
          defaultMessage="Discover similar job opportunities that match this position."
        />
      }
    />
  );
}

export { JobRecommenderJobs2Job };
